<dx-load-panel
    [visible]="appContext.nbRequestInProgress"
    [showIndicator]="true"
    [showPane]="false"
    [indicatorSrc]="indicatorUrl"
    [position]= "space"
    message=""
   >
</dx-load-panel>